<ng-template #aamBlockUI>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #aamBlock
    [class]="blockableClass"
    [style]="blockedStyle"
    [blocked]="isBlocked"
    [blockUi]="aamBlockUI"
>
    @if (address?.id) {
        <div class="w-full">
            <div style="text-align: center; margin: 1em">
                @if (isComponentRendered()) {
                    <app-asset-file-input
                        (selectFiles)="createAssets($event)"
                        [noUploadButton]="true"
                        [dropZoneTargetModelSig]="assetListRef().table()?.el"
                    />
                }
            </div>
            <app-widget-asset-list
                [dataTestId]="'formly-address-assets'"
                #assetList
                [showUploadButton]="true"
                [fillHeightList]="false"
                (isComponentRendered)="isComponentRendered.set(true)"
                (selectFiles)="createAssets($event)"
                [modelIdSig]="address.id"
                [modelTypeSig]="'AddressAsset'"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'common.journal-entries' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-journal-list-widget
                #journalListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'task.task-list' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-task-list-widget
                #taskListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />
        </div>
    }
</blockable-div>
